<template>
  <div>
      <div style="display: flex">
          <button
              type="button"
              class="btn btn-sm btn-clean btn-icon btn-icon-sm"
              title="تایید تراکنش و اضافه کردن به تراکنش های سامانه"
              :id="'model_btn_' + index"
              @click="openModal(index)"
          >
              <i class="fa fa-check"></i>
          </button>
      </div>
      <div :id="'approve_modal_' + index" class="modal fade rtl" role="dialog">
          <div class="modal-dialog">
              <div class="modal-content">
                  <div class="modal-header">
                      <div class="text-center font-weight-bold" id="tx_title"> تایید تراکنش و اضافه کردن به تراکنش های سامانه </div>
                      <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                  </div>
                  <div id="data_sheet" class="modal-body mb-4">
                      <form @submit.prevent="toggleCheck(index)">
                          <kt-col xs="12" sm="12" md="12">
                              <kt-form-group>
                                  <kt-form-label for="type">
                                      {{ $t("accounting.label.please_select_transaction_type") }}
                                  </kt-form-label>
                                  <select
                                      class="form-control"
                                      name="type"
                                      id="type"
                                      v-model="type"
                                  >
                                      <option v-for="(type, key) in TRANSACTION_TYPES" :key="key" :value="type">
                                          {{ TRANSACTION_TYPES_STR.get(type) }}
                                      </option>
                                  </select>
                              </kt-form-group>
                          </kt-col>
                          <button type="submit" :id="'submit_btn_' + index" class="btn btn-success">تایید تراکنش</button>
                      </form>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import Vue from "vue";
import {accountingService, starShopAccountingService} from "@/common/api.service";
import toastr from "toastr";
import {
    TRANSACTION_TYPES,
    TRANSACTION_TYPES_STR,
} from "@/constants/accountingTransactionType";
import $ from 'jquery';

export default Vue.extend({
  props: {
    row: {
      required: true,
    },
    index: {
      required: true,
    },
    datatable: {
      required: true,
    },
  },
  data() {
    return {
        type: null,
        TRANSACTION_TYPES,
        TRANSACTION_TYPES_STR,
    }
  },
  computed: {
    activeService() {
      return this.$route.path.includes('pf') ? accountingService : starShopAccountingService;
    },
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    },
  },
  methods: {
    openModal(index) {
        $(`#approve_modal_${index}`).modal('show')
    },
    toggleCheck(index) {
      this.activeService.addToTransactions({hashid: this.row.id, transaction_type: 1 , type: this.type}).then(
        (response) => {
          this.toastr.success(response.data.message);
          this.datatable.reload()
          $(`#approve_modal_${index}`).modal('hide')
        },
        (error) => {
          this.toastr.error(
            error.response.data.message || i18n.t("message.an_error_occurred")
          );
        }
      );
    },
  },
});
</script>

<style scoped>
.checked {
  color: green;
}
</style>